export enum COMPANY_USER_LIST_COLUMNS_VALUES {
  NAME = "name",
  EMAIL = "email",
  POSITION = "position",
  CREATED_AT = "createdAt",
  ACTIONS = "actions"
}

export const COMPANY_USER_LIST_COLUMNS = [
  COMPANY_USER_LIST_COLUMNS_VALUES.NAME,
  COMPANY_USER_LIST_COLUMNS_VALUES.EMAIL,
  COMPANY_USER_LIST_COLUMNS_VALUES.POSITION,
  COMPANY_USER_LIST_COLUMNS_VALUES.CREATED_AT,
  COMPANY_USER_LIST_COLUMNS_VALUES.ACTIONS
];
